<ng-container *ngIf="datum.tooltip; else noTooltipTemplate">
    <span [style.color]="datum.color" [tooltip]="datum.tooltip">{{ datum.label }}</span>
</ng-container>
<ng-template #noTooltipTemplate>
    <span [style.color]="datum.color">{{ datum.label }}</span>
</ng-template>
